export function getRecipientsInputErrorProps(error) {
  return error
    ? error?.length > 0
      ? { errorText: error }
      : { showError: true }
    : null
}
